import styled from '@emotion/styled'

const StyledContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 0.375rem 0;
  align-items: center;
  gap: 0.5rem;
`

export default StyledContainer
